/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const authorizationRequestResponseSchema = z.object({
  authorizationUri: z.string(),
});
